// 表格列宽度
// 在页面中使用 TABLE_COLUMN_WIDTH['WORD2']
export const TABLE_COLUMN_WIDTH = {
    WORD2: 64,
    WORD3: 78,
    WORD4: 92,
    WORD5: 106,
    WORD6: 120,
    WORD7: 134,
    WORD8: 148,
    WORD9: 162,
    WORD10: 176,
    WORD11: 190,
    WORD12: 204,
    WORD20: 350,
    WORD25: 420,
    WORD40: 596,
    DATE: 138,
    SHORT_DATE_TIME: 154,
    DATE_TIME: 188,
    MOBILE: 128
};

/* 表单项label宽度
    在页面中使用 FORM_LABEL_WIDTH['WORD2']
    必填项*星号算作一个汉字，要做长度计算
    label通常单行不超过5个字，超出可换行
 */
export const FORM_LABEL_WIDTH = {
    WORD2: 38,
    WORD3: 52,
    WORD4: 66,
    WORD5: 80,
    WORD6: 94,
    WORD7: 108,
    WORD8: 122,
    WORD9: 136,
    WORD10: 150,
    WORD11: 164,
    WORD12: 178
};
